import React from 'react';
import { ACTIVE_BRAND } from '../branding';
import './ConfigModal.css';

function ConfigModal({
  applicationTitle,
  setApplicationTitle,
  serialNumber,
  setSerialNumber,
  timeout,
  setTimeout,
  onClose
}) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ borderBottomColor: ACTIVE_BRAND.colors.primary }}>
          <h2 style={{ color: ACTIVE_BRAND.colors.primary }}>Configuration</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="appTitle">Application Title</label>
            <input
              id="appTitle"
              type="text"
              value={applicationTitle}
              onChange={(e) => setApplicationTitle(e.target.value)}
              placeholder="e.g., max gaming demo"
            />
          </div>

          <div className="form-group">
            <label htmlFor="serialNum">Scanner Serial Number</label>
            <input
              id="serialNum"
              type="text"
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
              placeholder="e.g., 54A20360001"
            />
          </div>

          <div className="form-group">
            <label htmlFor="timeoutVal">Scan Timeout (seconds)</label>
            <input
              id="timeoutVal"
              type="number"
              value={timeout}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '') {
                  setTimeout(''); // Allow empty string for typing
                } else {
                  const num = parseInt(val);
                  if (!isNaN(num)) {
                    setTimeout(num);
                  }
                }
              }}
              min="5"
              max="60"
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="save-button"
            onClick={onClose}
            style={{
              backgroundColor: ACTIVE_BRAND.colors.buttonBg,
              color: ACTIVE_BRAND.colors.buttonText
            }}
          >
            Save Settings
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfigModal;
